var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-action__button",attrs:{"title":_vm.title},on:{"click":ev => _vm.$emit('click', ev),"keydown":ev => _vm.$emit('keydown', ev)}},[_vm._t("default",function(){return [_c('i',{class:_vm.icon})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }